import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { DataPointEntry } from '../data-point-entry/DataPointEntry'

import type { FC } from 'react'
import type { DataPoint } from '../data-point-entry/DataPointEntry'

export type DataPointListProps = {
  description?: string
  dataPoints: DataPoint[]
}

const DataPointList: FC<DataPointListProps> = ({ description, dataPoints }) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.SpacingPx.Space4}>
      {description ? (
        <Span type='BodySmallRegular' color={theme.Colors.Neutrals.Darker} style={{ fontWeight: 400 }}>
          {description}
        </Span>
      ) : null}

      <FlexColumn gap='2px'>
        {dataPoints.map((dataPoint) => (
          <DataPointEntry key={dataPoint.label} dataPoint={dataPoint} />
        ))}
      </FlexColumn>
    </FlexColumn>
  )
}

export { DataPointList }
